// extracted by mini-css-extract-plugin
module.exports = {"ButtonBase":"ButtonBase-module--ButtonBase--fpyeW","disabled":"ButtonBase-module--disabled--36b8V","block":"ButtonBase-module--block--1YqwC"};